/* eslint-disable import/prefer-default-export */
import { scriptsReducerConstants } from '../reducerConstant';
import { ApiUtil } from '../../util/ApiUtil';

export const getAuthorizeScripts = () => async (dispatch) => {
  try {
    const res = await ApiUtil.getWithOutToken('util/getAuthorizedScripts');
    // Dispatch action to update the Redux store
    dispatch({ type: scriptsReducerConstants.FETCH_SCRIPTS, value: res.data });
  } catch (err) {
    dispatch({ type: scriptsReducerConstants.GET_AUTH_SCRIPTS_FAILURE });
  }
};

export const sendUnathScriptNotification = (unathScriptList) => async (dispatch) => {
  dispatch({ type: scriptsReducerConstants.GET_AUTH_SCRIPTS_REQUEST });
  ApiUtil.postWithoutToken('util/sendUnauthScriptNotificationNoToken', { unathScriptList })
    .then(() => {
    }).catch(() => {
    });
};
